import useUploadFile from './use-upload-file';

export default useUploadFile;
